import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

import { SharedWindow, SharedVerification } from "@/components/shared";
import { UIButton } from "@/components/ui";
import { getCookie } from "@/shared/utils/cookie-helpers";

import { CODE_MAX_LENGTH } from "@/shared/constants/constants";
import { DepositWithdrawalVerificationRequestFactory } from "@/shared/repository/modules/deposit-withdrawal/factory";
import { WalletModalFactory } from "@/shared/repository/modules/wallet/factory";
import { ModalFactory } from "@/shared/factory/modal";
import { getWithdrawalErrorMessages } from "@/shared/constants/withdrawal-errors";

import {
  ModalIcon,
  ModalLabel,
  ModalTitle,
} from "@/shared/constants/constants";

interface ApiError {
  response?: {
    data?: {
      message?: string;
    };
  };
  message?: string;
}

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    SharedWindow,
    SharedVerification,
    UIButton,
  },
  props: {
    modal: {
      default: WalletModalFactory(),
    },
  },
  data() {
    return {
      isError: false,
      isLoading: false,
      code: "",
      errorMessage: "",
      modalRepo: this.$projectServices.modalRepo,
      walletRepo: this.$projectServices.walletRepo,
      walletRepository: this.$projectServices.walletRepository,
    };
  },
  emits: {
    update: null,
    close: null,
  },
  computed: {
    isConfirmDisabled(): boolean {
      return this.isLoading || this.code.length !== CODE_MAX_LENGTH;
    },
  },
  methods: {
    getBalance(): void {
      const baseFiat = getCookie("balance_fiat_currency") || "USD";
      const baseCrypto = getCookie("balance_crypto_currency") || "USDT";
      this.walletRepo.wallet({ fiat: baseFiat, crypto: baseCrypto });
    },

    async handleVerification(): Promise<void> {
      try {
        this.isError = false;
        this.errorMessage = "";
        this.isLoading = true;

        await this.walletRepository.verification(
          DepositWithdrawalVerificationRequestFactory({
            code: this.code,
          })
        );

        this.walletRepo.UPDATE_MODAL(WalletModalFactory());
        this.modalRepo.UPDATE_MODAL(
          ModalFactory({
            title: ModalTitle.cryptoWithdrawal,
            label: ModalLabel.cryptoWithdrawal,
            icon: ModalIcon.application,
            callback: () => {},
          })
        );
      } catch (error: unknown) {
        this.isError = true;

        let apiMessage = "Unknown error";

        if (this.isApiError(error)) {
          apiMessage =
            error.response?.data?.message || error.message || "Unknown error";
        } else if (error instanceof Error) {
          apiMessage = error.message;
        }

        const errorMessages = getWithdrawalErrorMessages(apiMessage);

        if (errorMessages.ru === errorMessages.en) {
          this.errorMessage = errorMessages.ru;
        } else {
          this.errorMessage = `${errorMessages.ru}\n${errorMessages.en}`;
        }
      } finally {
        this.getBalance();
        this.$emit("update");
        this.isLoading = false;
      }
    },

    isApiError(error: unknown): error is ApiError {
      return (
        typeof error === "object" &&
        error !== null &&
        ("response" in error || "message" in error)
      );
    },

    handleClose(): void {
      this.$emit("close");
    },
  },
});
